import { useEffect, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

import {
  approvePendingRequest,
  fetchPending,
  rejectPendingRequest,
} from "./Api";
import ProfileModal from "./ProfileModal";

const PendingRequests = ({ titleReq = "PENDING REQUESTS" }) => {
  const [requests, setRequests] = useState([]);
  const [selectedRequesterId, setSelectedRequesterId] = useState(null);

  useEffect(() => {
    const load = async () => {
      const pending = await fetchPending();
      setRequests(pending);
    };
    load();
  }, []);

  const handleApprove = async (requesterId) => {
    try {
      await approvePendingRequest(requesterId);
      setRequests((prev) =>
        prev.filter((r) => r.requester_id !== requesterId)
      );
    } catch (err) {
      console.error("Approve failed:", err);
    }
  };

  const handleReject = async (requesterId) => {
    try {
      await rejectPendingRequest(requesterId);
      setRequests((prev) =>
        prev.filter((r) => r.requester_id !== requesterId)
      );
    } catch (err) {
      console.error("Reject failed:", err);
    }
  };

  return (
    <div>
      <h2 style={{ 
        fontSize: '20px',
          fontWeight: '700',
          fontStyle: 'bolder',
          color: '#740A03',
          fontFamily: 'Arial, sans-serif',
      }}>
        {titleReq}
      </h2>
      <ul style={{ padding: 0 }}>
        {requests.map((req) => {
          const {
            full_name,
            profile_image,
            requester_id,
            receiver_id,
          } = req;

          return (

            <li
              key={`${requester_id}-${receiver_id}`}
              style={{
                padding: "8px 0",
                borderBottom: "1px solid #ff9b45",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: '#740A03',
                fontFamily: 'Arial, sans-serif',
              }}
              onClick={() => setSelectedRequesterId(requester_id)}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {profile_image && profile_image !== "none" ? (
                  <img
                    src={profile_image}
                    alt={full_name || "Unknown User"}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <span
                    style={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "24px",
                      lineHeight: "1",
                      borderRadius: "50%",
                    }}
                  >
                    👤
                  </span>
                )}


                <span style={{ marginLeft: "20px" }}>
                  {full_name || "Unknown User"}
                </span>
              </div>


              <div style={{ display: "flex", gap: "10px" }}>
                <FaCheck
                  color="green"
                  style={{ cursor: "pointer" }}
                  title="Accept"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleApprove(requester_id);
                  }}
                />
                <FaTimes
                  color="red"
                  style={{ cursor: "pointer" }}
                  title="Reject"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleReject(requester_id);
                  }}
                />
              </div>
            </li>
          );

        })}
      </ul>

      {selectedRequesterId && (
        <ProfileModal
          userId={selectedRequesterId}
          onClose={() => setSelectedRequesterId(null)}
        />
      )}
    </div>
  );
};

export default PendingRequests;
